import { render, staticRenderFns } from "./button-licorne.vue?vue&type=template&id=82c9baf2&scoped=true&"
import script from "./button-licorne.vue?vue&type=script&lang=js&"
export * from "./button-licorne.vue?vue&type=script&lang=js&"
import style0 from "./button-licorne.vue?vue&type=style&index=0&id=82c9baf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c9baf2",
  null
  
)

export default component.exports